"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverviewSettings = exports.isTagsViewConcise = void 0;
var vue_1 = require("vue");
var isTagsViewConcise = function (root) {
    return root.getVisibilityState('tags_concise');
};
exports.isTagsViewConcise = isTagsViewConcise;
exports.OverviewSettings = vue_1.default.component('overview-settings', {
    methods: {
        toggleTagsView: function () {
            this.$root.setVisibilityState('tags_concise', !this.$root.getVisibilityState('tags_concise'));
        },
        getTagToggleLabel: function () {
            return exports.isTagsViewConcise(this.$root) ? 'full' : 'concise';
        },
    },
    template: "\n        <div class=\"players-overview-settings\">\n            <div class=\"setting-button\" v-on:click.prevent=\"toggleTagsView()\">{{ getTagToggleLabel() }}</div>\n            <div class=\"setting-label\">[ toggle tags view ]</div>\n        </div>\n    ",
});
//# sourceMappingURL=OverviewSettings.js.map